import { render, staticRenderFns } from "./MeusPromotoresRoute.vue?vue&type=template&id=cfed502a"
import script from "./MeusPromotoresRoute.vue?vue&type=script&lang=js"
export * from "./MeusPromotoresRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports